import { ProductAttributes, SingleBlockInfo } from "./product.model";

export interface WishListItem {
    id?: number;
    product?: ProductAttributes;
}

export enum ResponseMessage {
    Delete = "Remove Successfully",
    UpdateSuccess = "Updated Successfully",
    FailRemoveCart = "Fail to remove cart",
    Cannotfind = "Cannot find productID",
    QuantityUpdateFailed = "Failed to update quantity",
    AddSuccess = "Added Successfully",
    AddFailed = "Unable to add to cart",
    GetFailed = "Failed to get cart items",
}

export interface QuantityResponse {
    id?: number;
    quantity?: number;
    cartUUID?: string;
}

export interface BaseCart {
    productID: number;
    cartUUID?: string;
    quantity: number;
    userMobileNumber?: string;
    singleBlockInfo?: SingleBlockInfo | null;
}

export interface CartAttributes extends BaseCart {
    id?: number;
    product?: ProductAttributes;
}

export interface RemoveCartItem {
    productId?: number;
    cartUUID?: string;
}
